import React from "react";
import "./AppLoader.scss";

const AppLoader = () => {
  return (
    <div
      className="app-loader"
      role="status"
      aria-live="polite"
      aria-label="Loading HireNeuron workspace"
    >
      <div className="app-loader__content">
        <div className="app-loader__mark" aria-hidden="true">
          <span className="app-loader__orbit app-loader__orbit--one" />
          <span className="app-loader__orbit app-loader__orbit--two" />
          <span className="app-loader__core">
            <span />
            <span />
            <span />
          </span>
        </div>

        <div className="app-loader__brand">HireNeuron</div>
        <p className="app-loader__label">Preparing your workspace</p>

        <div className="app-loader__progress" aria-hidden="true">
          <span className="app-loader__progress-bar" />
        </div>
      </div>
    </div>
  );
};

export default AppLoader;
